import React, { Component } from 'react'
import clsx from 'clsx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import {
  CssBaseline, CircularProgress, Container, Button, Grid,
  Typography, Card, CardContent, Chip, IconButton, Tooltip,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper
} from '@mui/material'
import Pagination from '@mui/material/Pagination'
import { withStyles } from '@mui/styles'
import { Styles } from '../../styles/material-styles'
import { Overlay } from '../../styles/global'
import CustomizedSnackbars from '../../components/material-snackbars'
import HeaderMenu from '../../components/header-menu'
import Footer from '../../components/footer'
import { FormattedMessage, injectIntl } from 'react-intl'
import { AbilityContext } from '../../config/ability-context'
import Api from '../../services/api'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import ReplayIcon from '@mui/icons-material/Replay'
import ReceiptIcon from '@mui/icons-material/Receipt'
import { Link } from 'react-router-dom'
import { getInvoices, getUpcomingInvoice, retryInvoicePayment } from '../../services/billing.service'
import * as componentActions from '../../redux/actions/organizations'
import './index.css'

const PAGE_SIZE = 10

class BillingInvoices extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      openNotification: false,
      notificationVariant: 'error',
      notificationMessage: '',
      invoices: [],
      totalCount: 0,
      page: 1,
      upcomingInvoice: null,
      loadingUpcoming: false
    }

    this.closeNotification = this.closeNotification.bind(this)
  }

  async componentDidMount() {
    await this.loadInvoices()
  }

  async loadInvoices() {
    const { userSession } = this.props
    const hirerId = userSession.user.hirerid
    if (!hirerId) return

    const offset = (this.state.page - 1) * PAGE_SIZE
    this.setState({ loading: true })
    const result = await getInvoices(hirerId, PAGE_SIZE, offset)
    if (result && result.data && result.data.data) {
      const data = result.data.data
      this.setState({
        invoices: Array.isArray(data) ? data : (data.invoices || []),
        totalCount: data.totalCount || (Array.isArray(data) ? data.length : 0),
        loading: false
      })
    } else {
      this.setState({ loading: false })
    }
  }

  async loadUpcomingInvoice() {
    const { userSession } = this.props
    const intl = this.props.intl
    const hirerId = userSession.user.hirerid
    if (!hirerId) return

    this.setState({ loadingUpcoming: true })
    try {
      const result = await getUpcomingInvoice(hirerId)
      if (result && result.data && result.data.data && result.data.data.invoice) {
        this.setState({ upcomingInvoice: result.data.data.invoice, loadingUpcoming: false })
      } else {
        this.setState({
          upcomingInvoice: null,
          loadingUpcoming: false,
          openNotification: true,
          notificationVariant: 'info',
          notificationMessage: intl.formatMessage({ id: 'billing.no.upcoming.invoice' })
        })
      }
    } catch (err) {
      this.setState({
        loadingUpcoming: false,
        openNotification: true,
        notificationVariant: 'info',
        notificationMessage: intl.formatMessage({ id: 'billing.no.upcoming.invoice' })
      })
    }
  }

  handlePageChange = async (event, value) => {
    this.setState({ page: value }, async () => {
      await this.loadInvoices()
    })
  }

  handleRetryPayment = async (invoiceId) => {
    const intl = this.props.intl
    this.setState({ loading: true })
    const result = await retryInvoicePayment(invoiceId)
    if (result && result.data && result.data.success) {
      this.setState({
        openNotification: true,
        notificationVariant: 'success',
        notificationMessage: intl.formatMessage({ id: 'billing.retry.success' })
      })
      await this.loadInvoices()
    } else {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: result.data && result.data.errors && result.data.errors[0]
          ? result.data.errors[0]
          : intl.formatMessage({ id: 'billing.retry.error' })
      })
    }
  }

  getStatusColor(status) {
    const colors = {
      'paid': '#4caf50',
      'open': '#ff9800',
      'draft': '#2196f3',
      'void': '#9e9e9e',
      'uncollectible': '#f44336'
    }
    return colors[status] || '#757575'
  }

  getStatusLabel(status) {
    const intl = this.props.intl
    const labels = {
      'paid': intl.formatMessage({ id: 'billing.status.paid' }),
      'open': intl.formatMessage({ id: 'billing.status.open' }),
      'draft': intl.formatMessage({ id: 'billing.status.draft' }),
      'void': intl.formatMessage({ id: 'billing.status.void' }),
      'uncollectible': intl.formatMessage({ id: 'billing.status.uncollectible' })
    }
    return labels[status] || status
  }

  formatDate(dateStr) {
    if (!dateStr || dateStr === '0001-01-01T00:00:00') return '-'
    const d = new Date(dateStr)
    return d.toLocaleDateString('pt-BR')
  }

  formatCurrency(value, currency) {
    if (value == null) return '-'
    const cur = currency || 'BRL'
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: cur }).format(value)
  }

  closeNotification() {
    this.setState({ openNotification: false })
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props
    const intl = this.props.intl
    const totalPages = Math.ceil(this.state.totalCount / PAGE_SIZE)

    if (Api == null) {
      var l = this.props.match.params.lang
      document.location.href = `/${l}/unavailable`
    }

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })}>
          <div className={classes.drawerHeader} />
          <Container component='main' maxWidth='lg' style={{ paddingTop: 20 }}>
            <CssBaseline />

            <Grid container spacing={2} alignItems="center" style={{ marginBottom: 20 }}>
              <Grid item>
                <Button
                  component={Link}
                  to={`/${this.props.match.params.lang}/my-plan`}
                  startIcon={<ArrowBackIcon />}
                  color="primary"
                >
                  {intl.formatMessage({ id: 'back' })}
                </Button>
              </Grid>
              <Grid item xs>
                <Typography variant="h5" component="h1">
                  {intl.formatMessage({ id: 'billing.invoices' })}
                </Typography>
              </Grid>
            </Grid>

            {/* Botão para visualizar próxima fatura */}
            {this.state.invoices.length > 0 && !this.state.upcomingInvoice && (
              <Button
                variant="outlined"
                color="primary"
                onClick={() => this.loadUpcomingInvoice()}
                disabled={this.state.loadingUpcoming}
                style={{ marginBottom: 20 }}
                startIcon={<ReceiptIcon />}
              >
                {this.state.loadingUpcoming
                  ? intl.formatMessage({ id: 'loading' })
                  : intl.formatMessage({ id: 'billing.view.upcoming' })}
              </Button>
            )}

            {/* Card próxima fatura */}
            {this.state.upcomingInvoice && (
              <Card className="upcoming-invoice-card" style={{ marginBottom: 20 }}>
                <CardContent>
                  <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                    {intl.formatMessage({ id: 'billing.upcoming.invoice' })}
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={4}>
                      <Typography variant="h6">
                        {this.formatCurrency(this.state.upcomingInvoice.amountDue / 100, this.state.upcomingInvoice.currency)}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        {intl.formatMessage({ id: 'billing.amount.due' })}
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="h6">
                        {this.formatDate(this.state.upcomingInvoice.dueDate)}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        {intl.formatMessage({ id: 'billing.due.date' })}
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="h6">
                        {this.state.upcomingInvoice.currency ? this.state.upcomingInvoice.currency.toUpperCase() : 'BRL'}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        {intl.formatMessage({ id: 'billing.currency' })}
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            )}

            {/* Tabela de faturas */}
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>{intl.formatMessage({ id: 'billing.invoice.number' })}</TableCell>
                    <TableCell>{intl.formatMessage({ id: 'menu.statuses' })}</TableCell>
                    <TableCell align="right">{intl.formatMessage({ id: 'billing.value' })}</TableCell>
                    <TableCell>{intl.formatMessage({ id: 'billing.due.date' })}</TableCell>
                    <TableCell>{intl.formatMessage({ id: 'billing.paid.date' })}</TableCell>
                    <TableCell align="center">{intl.formatMessage({ id: 'billing.actions' })}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.invoices.length === 0 && !this.state.loading && (
                    <TableRow>
                      <TableCell colSpan={6} align="center" style={{ padding: 40 }}>
                        <ReceiptIcon style={{ fontSize: 48, color: '#bdbdbd', marginBottom: 8 }} />
                        <Typography variant="body1" color="textSecondary">
                          {intl.formatMessage({ id: 'billing.no.invoices' })}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                  {this.state.invoices.map((inv) => (
                    <TableRow key={inv.id}>
                      <TableCell>{inv.invoiceNumber || '-'}</TableCell>
                      <TableCell>
                        <Chip
                          label={this.getStatusLabel(inv.status)}
                          size="small"
                          className="invoice-status-chip"
                          style={{
                            backgroundColor: this.getStatusColor(inv.status),
                            color: '#fff'
                          }}
                        />
                      </TableCell>
                      <TableCell align="right">
                        {this.formatCurrency(inv.valueInvoice, inv.currency)}
                      </TableCell>
                      <TableCell>{this.formatDate(inv.dueDate)}</TableCell>
                      <TableCell>{this.formatDate(inv.datePaidInvoice)}</TableCell>
                      <TableCell align="center">
                        <div className="invoice-actions">
                          {inv.invoicePdfUrl && (
                            <Tooltip title={intl.formatMessage({ id: 'billing.view.pdf' })}>
                              <IconButton size="small" onClick={() => window.open(inv.invoicePdfUrl, '_blank')}>
                                <PictureAsPdfIcon />
                              </IconButton>
                            </Tooltip>
                          )}
                          {inv.hostedInvoiceUrl && (
                            <Tooltip title={intl.formatMessage({ id: 'billing.view.online' })}>
                              <IconButton size="small" onClick={() => window.open(inv.hostedInvoiceUrl, '_blank')}>
                                <OpenInNewIcon />
                              </IconButton>
                            </Tooltip>
                          )}
                          {inv.status === 'open' && (
                            <Tooltip title={intl.formatMessage({ id: 'billing.retry.payment' })}>
                              <IconButton size="small" color="warning" onClick={() => this.handleRetryPayment(inv.id)}>
                                <ReplayIcon />
                              </IconButton>
                            </Tooltip>
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {totalPages > 1 && (
              <Grid container justifyContent="center" style={{ marginTop: 20 }}>
                <Pagination
                  count={totalPages}
                  page={this.state.page}
                  onChange={this.handlePageChange}
                  color="primary"
                />
              </Grid>
            )}

          </Container>

          {this.state.loading && (
            <Overlay>
              <CircularProgress color='secondary' />
            </Overlay>
          )}

          <CustomizedSnackbars
            variant={this.state.notificationVariant}
            message={this.state.notificationMessage}
            isOpen={this.state.openNotification}
            toClose={this.closeNotification}
          />

        </main>
        <Footer />
      </div>
    )
  }
}

BillingInvoices.propTypes = {
  classes: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(componentActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(BillingInvoices)))

BillingInvoices.contextType = AbilityContext
